import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
  URL_PUBLIC,
} from '@retailer-platform/dashboard/routing'

const URL_DRAFT_MANAGEMENT = `${URL_RETAILER_SCOPED}/draft-management`
const URL_DRAFT_MANAGEMENT_LIST = `${URL_DRAFT_MANAGEMENT}/list`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'draft-management'>
  | DashRouteType<'draft-management-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'draft-management': URL_DRAFT_MANAGEMENT,
  'draft-management-list': URL_DRAFT_MANAGEMENT_LIST,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
